import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

const initState = {
  workers: [],
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, sortableColumns } = payload;
  const workers = data;

  return {
    ...state,
    workers,
    total,
    filteredTotal,
    sortableColumns,
    loading: false,
  };
}

function onLoadMyTeamList(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadMyTeamSuccess(state, { payload }) {
  const { data, total, filteredTotal, sortableColumns } = payload;
  const workers = data;

  return {
    ...state,
    workers,
    total,
    filteredTotal,
    sortableColumns,
    loading: false,
  };
}

function onLoadAfterAction(state, { payload }) {
  const { data } = payload;
  const { workers } = state;
  const index = workers.findIndex(item => {
    return item.id === data.id;
  });

  workers[index] = {
    ...data,
    isDateBold: true,
  };

  return {
    ...state,
    workers,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_MY_TEAM]: onLoadMyTeamList,
  [actions.LOAD_MY_TEAM_SUCCESS]: onLoadMyTeamSuccess,
  [actions.LOAD_AFTER_ACTION]: onLoadAfterAction,
  [actions.CLEAR_STORE]: onClearStore,
});
